export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/AD-9c507a2233a83dc3030c24129011aaf9.png";